import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../Styles/InputStyles";
import { capitalizeFirstLetter } from "../../helpers";
import { FaRegBuilding } from "react-icons/fa";
import Images from "../../Images";

const ViewAgreementDetails = ({ setIsViewAgreement, selectedData }) => {
    const onClose = () => {
        setIsViewAgreement(false);
    };

    return (
        <Container>
            <Header>
                <Title>Agreement Details</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ProfileSection className="px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
                        <img
                        src={selectedData?.profilePicture || Images.Avatar}
                        alt={selectedData?.tenantName}
                        className="w-9 h-9 rounded-full object-cover"
                        />                     
                      </div>
            
                      {/* Text Info */}
                      <div className="flex flex-col">
                        <p className="text-md font-medium text-gray-800">
                          {capitalizeFirstLetter(selectedData?.tenantName || "")}
                        </p>
                        <p className="text-xs text-gray-400">
                          {capitalizeFirstLetter(selectedData?.tenantMobile || "")}
                        </p>
                      </div>
                    </div>
            
                    {/* Right: Rent */}
                    <div className="text-right">
                      <p className="text-xs text-gray-400">Rent</p>
                      <p className="text-lg font-bold text-green-600">
                        ₹{selectedData?.rent || 0}
                      </p>
                    </div>
                  </ProfileSection>

            <Content>
                <ScrollableContent>
                    <Wrapper>
                        {/* CURRENT AGREEMENT DETAILS */}
                        <BtnWrapper>
                            <SectionTitle>New Agreement</SectionTitle>
                        </BtnWrapper>

                        <Section>
                            <Row>
                                <FlexCol>
                                    <Label>Inventory</Label>
                                    <Value>{selectedData?.inventoryName || ""}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Agreement Period</Label>
                                    <Value>{selectedData?.agreementPeriod} Months</Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Rent</Label>
                                    <Value>₹{selectedData?.rent}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Security</Label>
                                    <Value>₹{selectedData?.security}</Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Agreement Start Date</Label>
                                    <Value>
                                        {selectedData?.agreementStartDate
                                            ? moment(selectedData?.agreementStartDate).format(
                                                "DD, MMM YY"
                                            )
                                            : "-"}
                                    </Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Agreement End Date</Label>
                                    <Value>
                                        {selectedData?.agreementStartDate &&
                                            selectedData?.agreementPeriod
                                            ? moment(selectedData?.agreementStartDate)
                                                .add(selectedData?.agreementPeriod, "months")
                                                .format("DD, MMM YY")
                                            : "-"}
                                    </Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Lock-In Period</Label>
                                    <Value>{selectedData?.lockInPeriod} Months</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Notice Period</Label>
                                    <Value>{selectedData?.noticePeriod} Months</Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Done By</Label>
                                    <Value>{selectedData?.doneByName || "-"}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Renewed Date</Label>
                                    <Value>
                                        {selectedData?.createdAt
                                            ? moment(selectedData?.createdAt).format(
                                                "DD, MMM YY hh:mm A"
                                            )
                                            : "-"}
                                    </Value>
                                </FlexCol>
                            </Row>
                        </Section>

                        {/* PREVIOUS AGREEMENT DETAILS */}
                        <BtnWrapper>
                            <SectionTitle>Previous Agreement</SectionTitle>
                        </BtnWrapper>

                        <Section>

                            <Row>
                                <FlexCol>
                                    <Label>Rent</Label>
                                    <Value>₹{selectedData?.prevRent ?? "-"}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Security</Label>
                                    <Value>₹{selectedData?.prevSecurity ?? "-"}</Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Agreement Start Date</Label>
                                    <Value>
                                        {selectedData?.prevAgreementStartDate
                                            ? moment(selectedData?.prevAgreementStartDate).format(
                                                "DD, MMM YY"
                                            )
                                            : "-"}
                                    </Value>
                                </FlexCol>

                                <FlexCol>
                                    <Label>Agreement End Date</Label>
                                    <Value>
                                        {selectedData?.prevAgreementStartDate &&
                                            selectedData?.prevAgreementPeriod
                                            ? moment(selectedData?.prevAgreementStartDate)
                                                .add(selectedData?.prevAgreementPeriod, "months")
                                                .format("DD, MMM YY")
                                            : "-"}
                                    </Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Lock-In Period</Label>
                                    <Value>{selectedData?.prevLockInPeriod} Months</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Notice Period</Label>
                                    <Value>{selectedData?.prevNoticePeriod} Months</Value>
                                </FlexCol>
                            </Row>

                            <Row>
                                <FlexCol>
                                    <Label>Agreement Period</Label>
                                    <Value>{selectedData?.prevAgreementPeriod} Months</Value>
                                </FlexCol>
                            </Row>
                        </Section>
                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

/* Styled Components */
const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;

export default ViewAgreementDetails;
